import { useScript } from 'usehooks-ts';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/cmp-vendor-list/cmp-vendor-list.css';

export default function CmpVendorList() {
  const cmpId = useAppSelector(ConfigSlice.selectors.cmpId);

  useScript(`https://delivery.consentmanager.net/delivery/vendorlist.php?cdid=${cmpId}&l=de`, {
    id: 'cookie-info',
    shouldPreventLoad: false,
    removeOnUnmount: true,
  });

  return <div id='cmpvendorlist' className='cmp-vendor-list' />;
}
